import { BASE_API_URL } from "@src/constants"
import { ax } from "@src/utils/axios"

interface Options {
    Comment: string,
    ShiftID: number,
    Date: string,
    CreatedBy: string,
    Active: boolean,
    IsAcknowledge: boolean,
}

export const apiCreateShiftNote = ({
    Comment,
    ShiftID,
    Date,
    CreatedBy,
    Active,
    IsAcknowledge
}: Options) => {
    const data = {
        Comment,
        ShiftID,
        Date,
        CreatedBy,
        Active,
        IsAcknowledge
    }
    const options = {
        method: 'POST',
        url: `${BASE_API_URL}/ref/shiftNotes`,
        data: data
    }
    return ax(options)
}